import { Invitation } from './components/Invitation';
import '../../../index.scss';

const ReferralInvite = Invitation;

export default ReferralInvite;
